import type { Board } from "../board";
import { PRIORITY_LAST, type ProcessableThing } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class DebugIndicator extends PhysicalThing implements ProcessableThing {
	static key = "DebugIndicator";
	constructor(xy: XY) {
		super(xy, false);
	}

	isVisible(): boolean {
		return true;
	}

	getZOrder(): number {
		return ZOrder.TOP;
	}

	isHideUnderneath(): boolean {
		return false;
	}

	processTurn(board: Board): void {
		board.removeAtEndOfTurn(this);
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	static deserialize(data: any): DebugIndicator {
		const d = new DebugIndicator(deserializeXY(data.xy));
		d.visualId = data.visualId;
		return d;
	}
}
